import React from "react";
import { useNavigate } from "react-router-dom"; // Import navigation
import Card from "../components/Card";
import { FaChartBar, FaNetworkWired, FaClipboardList, FaDesktop } from "react-icons/fa";
import "../design/Home.css"; // Import custom CSS
import { logActiveTestbed } from '../api/api';
import { useEffect } from "react";

const Home = () => {
  const navigate = useNavigate(); // Initialize navigation
  useEffect(() => { logActiveTestbed('Home mounted'); }, []);

  return (
    <div className="home-container">
      <h1 className="home-title">Home</h1>
      <div className="card-grid">
        <Card icon={<FaNetworkWired />} title="Application Overview" onClick={() => navigate("/applications")} />
        <Card
  icon={<FaChartBar />}
  title="Data Visualisation"
  onClick={() => navigate("/kentyouhome")} 
/>
       <Card icon={<FaDesktop />} title="Monitoring" onClick={() => navigate("/monitoring-manager")} />
        <Card icon={<FaClipboardList />} title="Service Request" onClick={() => navigate("/service-request")} />
      </div>
    </div>
  );
};

export default Home;
